import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class SurveysService extends BaseService<Survey, 'surveyID', 'surveys'> {
	constructor() {
		super('surveyID', 'survey', 'surveys');
	}

	async copySurvey(payload: { surveyID: number; name: string }) {
		const response = await axiosInstance.post(
			'app/surveys/duplicate',
			payload,
		);
		return response;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SurveysService();
